export default __webpack_public_path__ + "static/media/Snd2.78d67b4d.mp3";